import { useEffect, useMemo, useRef, useState } from 'react'
import { useActsStore } from '../store/useActsStore'
import { useInterestPointStore } from '../store/uneInterestPointsStore'
import { useIsMobile, useIsTouch } from '../utils/useIsMobile'
import { useAudioStore } from '../store/useAudioStore'
import { useFrame } from '@react-three/fiber'


export default function Ui() {

    const isTouch = useIsTouch()
    const isMobile = useIsMobile()
    const holdProgress = useActsStore(s => {
        const id = s.getCurrentActId()
        return id != null ? (s.actsProgress[id]?.holdProgress ?? 0) : 0
    })

    const id = useActsStore(s => s.getCurrentActId())
    const points = useInterestPointStore(s => s.points)
    const ids = useMemo(() => Object.keys(points), [points])

    const isActe4 = id === 3
    const isActe3 = id === 2
    const isActe3End = isActe3 && holdProgress > 0.98

    const refNoActeFour = useRef(null)
    const refActeFour = useRef(null)
    const refScrollRed = useRef(null)
    const refPoints = useRef(null)

    const audioEnabled = useAudioStore((s) => s.enabled)

    useEffect(() => {
        const DURATION = 350
        const timers = []

        const applyDisplayWithDelay = (el, shouldBeVisible, displayValue) => {
            if (!el) return

            if (shouldBeVisible) {
                el.style.display = "none"

                const t = window.setTimeout(() => {
                    if (!el.classList.contains("invisible")) {
                        el.style.display = displayValue
                    }
                }, DURATION)

                timers.push(t)
                return
            }

            const t = window.setTimeout(() => {
                if (el.classList.contains("invisible")) {
                    el.style.display = "none"
                }
            }, DURATION)

            timers.push(t)
        }

        applyDisplayWithDelay(refNoActeFour.current, !isActe4, "block")
        applyDisplayWithDelay(refScrollRed.current, !isActe4, "flex")

        applyDisplayWithDelay(refActeFour.current, isActe4, "block")
        applyDisplayWithDelay(refPoints.current, isActe4, "flex")

        return () => {
            for (const t of timers) window.clearTimeout(t)
        }
    }, [isActe4])

    function useHideHintsOnInput() {
        const [hideScrollIcon, setHideScrollIcon] = useState(false);
        const [hideMoveIcon, setHideMoveIcon] = useState(false);

        const scrollTimerRef = useRef(null);
        const mouseTimerRef = useRef(null);



        useEffect(() => {
            const HIDE_DELAY = 1300;

            const onUserScroll = () => {
                setHideScrollIcon(true);

                if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
                scrollTimerRef.current = setTimeout(() => {
                    setHideScrollIcon(false);
                }, HIDE_DELAY);
            };

            const onUserMouseMove = () => {
                setHideMoveIcon(true);

                if (mouseTimerRef.current) clearTimeout(mouseTimerRef.current);
                mouseTimerRef.current = setTimeout(() => {
                    setHideMoveIcon(false);
                }, HIDE_DELAY);
            };

            // Scroll desktop + mobile
            window.addEventListener("scroll", onUserScroll, { passive: true });
            window.addEventListener("wheel", onUserScroll, { passive: true });
            window.addEventListener("touchmove", onUserScroll, { passive: true });

            // Mouse move (desktop)
            window.addEventListener("mousemove", onUserMouseMove, { passive: true });

            return () => {
                window.removeEventListener("scroll", onUserScroll);
                window.removeEventListener("wheel", onUserScroll);
                window.removeEventListener("touchmove", onUserScroll);
                window.removeEventListener("mousemove", onUserMouseMove);

                if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
                if (mouseTimerRef.current) clearTimeout(mouseTimerRef.current);
            };
        }, []);


        return { hideScrollIcon, hideMoveIcon };
    }

    const { hideScrollIcon, hideMoveIcon } = useHideHintsOnInput();
    const showScrollIcon = (!isActe3 || isActe3End) && !isActe4
    const showMoveIcon = isActe3 && !isActe3End

    const scrollIconVisible = showScrollIcon && (isActe3End || !hideScrollIcon)
    const moveIconVisible = showMoveIcon && !hideMoveIcon


    return (
        <>
            <div className="ui-container">
                <div className="info-container">
                    <p>Robin - Creative developper</p>
                    <p>contact@robin-thomas.me</p>

                </div>

                <div className="bottom-ui">
                    <div className="left-container">
                        <div
                            ref={refNoActeFour}
                            className={`no-acte-four ${isActe4 ? "invisible" : "visible"}`}

                        >
                            {!isMobile ? <p className='continue-to-scroll'>Scroll to continue</p> : ''}
                            <div className="scroll-lenght-container">
                                <div className="scroll-lenght-white scroll-lenght"></div>
                            </div>
                        </div>

                        <div
                            ref={refActeFour}
                            className={`acte-four ${isActe4 ? "visible" : "invisible"}`}
                        >
                            <p>Follow stairs</p>
                        </div>
                    </div>

                    <div className={`mid-container ${isActe4 ? "invisible" : "visible"}`}>
                        <div className="icon-container">
                            <div className={`scroll-icon ${scrollIconVisible ? "visible" : "invisible"}`}>
                                <img className='mouse' src={`${isTouch ? "./img/icons/phone.svg" : "./img/icons/mouse.svg"}`} alt="Scroll icon" />
                                <img className='direction' src="./img/icons/scrolldirection.svg" alt="Scroll bottom direction icon" />
                                <img className='direction' src="./img/icons/scrolldirection.svg" alt="Scroll bottom direction icon" />
                                <img className='direction' src="./img/icons/scrolldirection.svg" alt="Scroll bottom direction icon" />
                            </div>

                            <div className={`move-icon ${moveIconVisible ? "visible" : "invisible"}`}>
                                <img className='mousemove' src='./img/icons/mousemove.svg' alt="" />
                                <img className='mouse' src={`${isTouch ? "./img/icons/phone.svg" : "./img/icons/mouse.svg"}`} alt="Scroll icon" />
                            </div>
                        </div>
                    </div>
                    <div className="right-container">
                        <div className="rs-container">
                            <a target="_blank" href="https://www.instagram.com/maestromdigital/"><img src="./img/icons/instagram.svg" alt="" /></a>
                            <a target="_blank" href="https://www.linkedin.com/in/robin-thomas-08ab10172/"><img src="./img/icons/linkedin.svg" alt="" /></a>
                        </div>
                        <button onClick={() => window.__audioToggle?.()} className={`sound-btn ${audioEnabled ? "active" : ""} `}>
                            <div className="sound-bar"></div>
                            <div className="sound-bar"></div>
                            <div className="sound-bar"></div>
                            <div className="sound-bar"></div>
                        </button>
                    </div>
                </div>
            </div>

            <div className="ui-container-no-blend">
                <div className="div-top"></div>
                <div className="bottom-ui">
                    <div className="left-container">
                        <div
                            ref={refScrollRed}
                            className={`scroll-lenght-container ${isActe4 ? "invisible" : "visible"}`}
                        >
                            <div
                                className="scroll-lenght-red scroll-lenght eheo"
                                style={{ width: holdProgress.toFixed(2) * 292 }}
                            />
                        </div>
                        <div
                            ref={refPoints}
                            className={`points-container ${isActe4 ? "visible" : "invisible"}`}
                        >
                            {ids.map(pointId => {
                                const visited = points[pointId]?.visited
                                return (
                                    <div
                                        key={pointId}
                                        className={`point ${visited ? "visited" : "empty"}`}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
